export const buildLessonFromSessionTemplate = (template = {}) => {
    const sections = Array.isArray(template.sections)
        ? template.sections
        : [];

    return {
        id: template.id || "",
        name: template.name || "Untitled Lesson",
        description: template.description || "",

        sections: sections.map((section, index) => ({
            id: section.id || `${template.id || "lesson"}-section-${index + 1}`,
            order: index + 1,
            title: section.title || `Section ${index + 1}`,
            type: section.type || "lesson",
            description: section.description || "",
            materials: Array.isArray(section.materials)
                ? section.materials
                : [],
            plannedMinutes:
                Number(section.plannedMinutes) ||
                Number(section.planned_minutes) ||
                0,
            questId:
                section.questId ||
                section.quest_id ||
                null,
        })),

        autoStartNextSection:
            Boolean(template.autoStartNextSection),

        autoEndClassAfterLastSection:
            Boolean(template.autoEndClassAfterLastSection),

        resources: Array.isArray(template.resources)
            ? template.resources
            : [],

        slides: Array.isArray(template.slides)
            ? template.slides
            : [],

        attachments: Array.isArray(template.attachments)
            ? template.attachments
            : [],

        createdAt:
            template.created_at ||
            template.createdAt ||
            null,

        updatedAt:
            template.updated_at ||
            template.updatedAt ||
            null,

        /*
            Compatibility

            We keep the original object available while
            the existing calendar/session system still
            uses its current field names.
        */
        sourceSessionTemplate: template,
    };
};

export const buildLessonFromCalendarFlow = ({
    calendarSections = [],
    savedTemplate = null,
} = {}) => {
    const orderedSections = [...calendarSections].sort(
        (a, b) =>
            Number(a.session_order || 0) -
            Number(b.session_order || 0)
    );

    const firstSection = orderedSections[0] || {};

    return {
        id:
            firstSection.session_lesson_template_id ||
            savedTemplate?.id ||
            firstSection.session_flow_id ||
            "",

        occurrenceId:
            firstSection.session_flow_id ||
            "",

        name:
            firstSection.session_lesson_name ||
            savedTemplate?.name ||
            "Today's Lesson",

        description:
            savedTemplate?.description ||
            "",

        date:
            firstSection.date_start ||
            firstSection.date ||
            firstSection.due_date ||
            "",

        childId:
            firstSection.child_id ||
            "",

        subjectId:
            firstSection.subject_id ||
            "",

        sections: orderedSections.map(
            (calendarSection, index) => {
                const templateSection =
                    savedTemplate?.sections?.[index] ||
                    null;

                return {
                    id: calendarSection.id,

                    order:
                        Number(
                            calendarSection.session_order
                        ) || index + 1,

                    title:
                        calendarSection.title ||
                        templateSection?.title ||
                        `Section ${index + 1}`,

                    type:
                        calendarSection.type ||
                        templateSection?.type ||
                        "lesson",

                    description:
                        calendarSection.description ||
                        templateSection?.description ||
                        "",

                    materials:
                        Array.isArray(
                            calendarSection.materials
                        )
                            ? calendarSection.materials
                            : Array.isArray(
                                  calendarSection.materials_needed
                              )
                            ? calendarSection.materials_needed
                            : Array.isArray(
                                  templateSection?.materials
                              )
                            ? templateSection.materials
                            : [],

                    plannedMinutes:
                        Number(
                            calendarSection.duration_minutes
                        ) ||
                        Number(
                            templateSection?.plannedMinutes
                        ) ||
                        0,

                    completed:
                        calendarSection.completed === true ||
                        calendarSection.status ===
                            "completed",

                    calendarEventId:
                        calendarSection.id,

                    questId:
                        calendarSection.quest_id ||
                        templateSection?.questId ||
                        templateSection?.quest_id ||
                        null,
                };
            }
        ),

        autoStartNextSection:
            Boolean(
                savedTemplate?.autoStartNextSection
            ),

        autoEndClassAfterLastSection:
            Boolean(
                savedTemplate?.autoEndClassAfterLastSection
            ),

        resources:
            Array.isArray(savedTemplate?.resources)
                ? savedTemplate.resources
                : [],

        slides:
            Array.isArray(savedTemplate?.slides)
                ? savedTemplate.slides
                : [],

        attachments:
            Array.isArray(savedTemplate?.attachments)
                ? savedTemplate.attachments
                : [],

        sourceSessionTemplate:
            savedTemplate,

        sourceCalendarSections:
            orderedSections,
    };
};